import { render, staticRenderFns } from "./OrganizationEditModal.vue?vue&type=template&id=33bfeadf&scoped=true&"
import script from "./OrganizationEditModal.vue?vue&type=script&lang=js&"
export * from "./OrganizationEditModal.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationEditModal.vue?vue&type=style&index=0&id=33bfeadf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bfeadf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33bfeadf')) {
      api.createRecord('33bfeadf', component.options)
    } else {
      api.reload('33bfeadf', component.options)
    }
    module.hot.accept("./OrganizationEditModal.vue?vue&type=template&id=33bfeadf&scoped=true&", function () {
      api.rerender('33bfeadf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/home/components/organization/modals/OrganizationEditModal.vue"
export default component.exports